/** Turn Maestro model dumps into readable markdown without another model call. */
export function normalizeMaestroMarkdown(raw: string): string {
  let text = String(raw || '').replace(/\r\n/g, '\n').replace(/\t/g, '  ').trim();
  if (!text) return '';

  text = text.replace(/[ \t]*•[ \t]*/g, '\n- ');
  text = text.replace(/([:)])[ \t]+-[ \t]+/g, '$1\n- ');

  // Standalone **Heading** or **Heading:** → markdown heading
  text = text.replace(/^\s*\*\*([^*]+)\*\*\s*:?\s*$/gm, '### $1');
  // **Heading:** rest of paragraph
  text = text.replace(/^\s*\*\*([^*]+)\*\*:\s+(\S.*)$/gm, '### $1\n\n$2');

  // Numbered steps jammed into one paragraph: "1. Foo 2. Bar"
  text = text.replace(/(^|[^\d])(\d{1,2})\.\s+(?=[A-Z*"“])/gm, (_full, pre: string, n: string) => {
    const prefix = pre === '' || pre === '\n' ? pre : `${pre}\n`;
    return `${prefix}${n}. `;
  });

  // "Title: " after a sentence → new line
  text = text.replace(/([.!?])[ \t]+(?=[A-Z][\w .()/]{3,80}:)/g, '$1\n\n');

  text = text.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n');
  return text.trim();
}
